import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from '@angular/common';

import swal from 'sweetalert2';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoCliente } from '../../servicos/srv.cliente';

@Component({
  selector: 'tsv2-cli-visualizar',
  templateUrl: './visualizar.component.html',
  providers: [ ServicoMsg, ServicoCliente ]
})
export class ClienteVisualizarComponent implements OnInit {
  p: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoCliente: ServicoCliente
  ) { }

  ngOnInit() {
    // this.spinner.show();
    const id = this.route.snapshot.params['id'];
    this.servicoCliente.consultarCliente(id).subscribe(res => {
      this.p = res.lista[0];
      // this.spinner.hide();
    }, (err) => {
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

  removerCliente(id){
    let titulo = 'Remover o cliente?';
    let url = '/cliente/pesquisar/';
    let texto = 'Cliente removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoCliente, texto).then(r1 => {
      if (r1.success){
        this.router.navigate([url]);
      }
    }, (err: any) => {
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
